module.exports = __webpack_public_path__ + "./static/img/csv.1456da231c3ae19e30b71d5fa103b0b3.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/csv.png
// module id = ./client/src/assets/fontawesome/csv.png
// module chunks = 0